import { CloudAlert, SearchX, Shredder } from "lucide-react";
import { Button } from "./ui/button";

interface BlockingMessageProps {
    message?: string;
    type: BlockingMessageType;
    continueAction?: () => void;
    continueMessage?: string;
}

export const BlockingMessageType = {
    NotFound: 0,
    NoPermission: 1,
    ServerError: 2
} as const;

// Create a type from the values of the const object
export type BlockingMessageType = typeof BlockingMessageType[keyof typeof BlockingMessageType];

export function BlockingMessage({ message, type, continueAction, continueMessage }: BlockingMessageProps) {

    const iconType = () => {
        switch (type) {
            case BlockingMessageType.NotFound:
                return <SearchX size={48} />
            case BlockingMessageType.NoPermission:
                return <Shredder size={48} />
            case BlockingMessageType.ServerError:
                return <CloudAlert size={48} />
            default:
                return <></>;
        }
    };

    return (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-background/80">
            {iconType()}
            <p className="text-center mr-4 ml-4 mt-4 text-lg text-muted-foreground">{message}</p>
            {continueAction && continueMessage && (
                <Button onClick={continueAction} size='lg' variant='link'>
                    {continueMessage}
                </Button>
            )}
        </div>
    );
}